import { Tab, TabList } from '@simplywallst/ui-core';
import { useState } from 'react';
import type { ReactNode } from 'react';
import { Badge } from '@simplywallst/ui-core/next';
import { useFlag } from '@simplywallst/unleash';

type TabValue = 'narrative' | 'updates';

type Props = {
  updateCount: number;
  children: (tab: TabValue) => ReactNode;
};

export const NarrativeViewTabs = ({ updateCount, children }: Props) => {
  const [tab, setTab] = useState<TabValue>('narrative');
  const { enabled } = useFlag('mono-narrative-updates-view');

  if (!enabled) return <div>{children('narrative')}</div>;

  return (
    <div>
      <TabList className="mb-x1 grid grid-cols-[max-content_max-content] gap-x1 border-0 border-b border-solid border-b-subtle">
        <Tab<TabValue>
          value="narrative"
          selected={tab === 'narrative'}
          styleType="subnav"
          onClick={() => setTab('narrative')}
        >
          Narrative
        </Tab>
        <Tab<TabValue>
          value="updates"
          selected={tab === 'updates'}
          styleType="subnav"
          onClick={() => setTab('updates')}
          disabled={updateCount === 0}
        >
          <div className="flex items-center gap-x1">
            Updates
            <Badge tone="default" variant="solid">
              {updateCount}
            </Badge>
          </div>
        </Tab>
      </TabList>
      <section>{children(tab)}</section>
    </div>
  );
};
